import React from 'react';
import Card from 'react-bootstrap/Card'
import Link from './Link'

export default function Disclaimer(props) {

    return (
        <div style={{marginBottom: '20px', fontStyle: 'italic', fontSize: '10pt'}}>
            <Card>
                <Card.Body>
                    <span class="d-none d-md-block">
                        This site is part of an effort by the U.S. Interagency
                        Wildland Fire Air Quality Response Program to track
                        {(!props.aqOnly) ? (<span> COVID and </span>) : (<span> </span>)}
                        air quality across the United States. The data,
                        report, and assessment category levels are provided
                        only for informational use and convenience and should
                        not be considered as guidance or authoritative.
                        Broader analyses should be performed before any
                        decisions are made. The data presented here may
                        contain significant errors and should be verified.
                        This page is experimental; use at own risk.
                    </span>
                    <span class="d-block d-md-none">
                        This page is experimental; use at own risk. <Link to={props.aboutLink || '/tracking/region/about/'}>More info</Link>
                    </span>
                </Card.Body>
            </Card>
        </div>
    )
}
